<script>
import { provide, inject, computed } from 'vue'

export default {
  name: 'FormProvider',
  props: {
    bgColor: {
      type: String,
      default: null
    },
    borderColor: {
      type: String,
      default: null
    },
    borderColorFocus: {
      type: String,
      default: null
    },
    borderColorHover: {
      type: String,
      default: null
    },
    labelColorFocus: {
      type: String,
      default: null
    },
    // Add more form settings here as needed
    settings: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, { slots }) {
    // Inject parent form settings if they exist
    const parentFormSettings = inject('form', null)
    
    // Default settings
    const defaults = {
      bgColor: 'base-100',
      borderColor: 'form-border',
      borderColorFocus: 'form-border-focus',
      borderColorHover: 'form-border-hover',
      labelColorFocus: 'base-content'
    }
    
    // Computed form settings object that merges parent, defaults, and current props
    const formSettings = computed(() => {
      // Start with defaults
      let merged = { ...defaults }
      
      // Merge parent settings if they exist
      if (parentFormSettings) {
        merged = { ...merged, ...parentFormSettings }
      }
      
      // Merge explicit props (only if they're not null)
      const explicitProps = {
        ...(props.bgColor !== null && { bgColor: props.bgColor }),
        ...(props.borderColor !== null && { borderColor: props.borderColor }),
        ...(props.borderColorFocus !== null && { borderColorFocus: props.borderColorFocus }),
        ...(props.borderColorHover !== null && { borderColorHover: props.borderColorHover }),
        ...(props.labelColorFocus !== null && { labelColorFocus: props.labelColorFocus })
      }
      
      // Merge settings prop and explicit props
      return {
        ...merged,
        ...props.settings,
        ...explicitProps
      }
    })

    // Provide merged form settings to child components
    provide('form', formSettings.value)

    // Return render function that directly renders slot content without wrapper
    return () => slots.default?.()
  }
}
</script>